import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import { NuveiHelpers } from "app/helpers/nuveiHelpers";
import { UserType } from "app/types/userType";
import { FundingTypes } from "app/utils/const";
import { FormattedMessage } from "react-intl";
import TransactionStatusComponent from "../TransactionStatusComponent/TransactionStatusComponent";

type Props = {
  transactionStatus: string;
  newPayment: Function;
  transactionType: string;
  user: UserType;
};

const TransactionResult: React.FC<Props> = ({
  transactionStatus,
  newPayment,
  transactionType,
  user,
}) => {
  const I18n = NuveiHelpers.nuveiTranslations();
  const paymentText =
    transactionType === FundingTypes.DEPOSIT
      ? I18n.payment.id
      : transactionType === FundingTypes.WITHDRAWAL
      ? I18n.payout.id
      : "";

  const newPaymentText =
    transactionType === FundingTypes.DEPOSIT
      ? I18n.newPayment.id
      : transactionType === FundingTypes.WITHDRAWAL
      ? I18n.newPayout.id
      : "";

  return (
    <>
      <div className="payment-result">
        <div className="payment-result__text">
          {transactionType === FundingTypes.DEPOSIT &&
            (user.firstTimeUser ? (
              <GeniusSiteTracking
                accountID={user.accountId}
                targetSelector=".payment-result__text"
                eventType="change"
                pageName={"firstdepositconfirm"}
                trackPageLoad={true}
              />
            ) : (
              <GeniusSiteTracking
                accountID={user.accountId}
                targetSelector=".form-submitted__content__info"
                eventType="change"
                pageName={"depositconfirm"}
                trackPageLoad={true}
              />
            ))}
          {<FormattedMessage tagName="span" id={`${paymentText}`} />} &nbsp;
        </div>
        <TransactionStatusComponent transactionStatus={transactionStatus} />
      </div>
      <button
        onClick={(e: any) => newPayment(e)}
        disabled={false}
        className="pay-by-card"
      >
        <FormattedMessage tagName="div" id={`${newPaymentText}`} />
      </button>
    </>
  );
};

export default TransactionResult;
